import React, { useMemo, useState } from "react";
import AgendaView from "./AgendaView";
import './CssFiles/indexcss.css'

export default function DemoAgenda() {
  const [currentView] = useState("agenda");
  const [currentAgendaTab, setCurrentAgendaTab] = useState("Scheduled");
  const [miniSelectedDate, setMiniSelectedDate] = useState(""); // "YYYY-MM-DD" or ""

  // Static demo data (same structure as your app)
  const appointments = useMemo(
    () => [
      {
        _id: "ag1",
        date: "2025-08-19",
        startTime: "13:00",
        Duration: 45,
        dob: "1985-12-29",
        patientRequestId: { firstName: "Robert", lastName: "Lee" },
        doctorRequestId: { firstName: "Nina", lastName: "Singh" },
        deliveryMode: { name: "Telehealth" },
        serviceLocationId: { name: "Virtual" },
        visitReason: { visitReason: "New Patient", cptCode: "99202" },
        appointmentStatus: { name: "Pending", agendatab: "Pending" },
      },
      {
        _id: "ag2",
        date: "2025-08-21",
        startTime: "11:00",
        Duration: 30,
        dob: "1978-06-01",
        patientRequestId: { firstName: "Mina", lastName: "Khan" },
        doctorRequestId: { firstName: "John", lastName: "Miller" },
        deliveryMode: { name: "In-Person" },
        serviceLocationId: { name: "Downtown Center" },
        visitReason: { visitReason: "Consult", cptCode: "99441" },
        appointmentStatus: { name: "Scheduled", agendatab: "Scheduled" },
      },
      {
        _id: "ag3",
        date: "2025-08-23",
        startTime: "16:00",
        Duration: 60,
        dob: "2001-03-20",
        patientRequestId: { firstName: "Sara", lastName: "Patel" },
        doctorRequestId: { firstName: "Akash", lastName: "Gupta" },
        deliveryMode: { name: "Telehealth" },
        serviceLocationId: { name: "Main Clinic" },
        visitReason: { visitReason: "Procedure", cptCode: "11042" },
        appointmentStatus: { name: "Finished", agendatab: "Finished" },
      },
    ],
    []
  );

  return (
    <div className="agenda-wrapper">
      {/* optional mini date filter for demo */}
      <div className="agenda-bar">
        <div className="agenda-title">Agenda</div>
        <input
          className="agenda-date-input"
          type="date"
          value={miniSelectedDate}
          onChange={(e) => setMiniSelectedDate(e.target.value)}
        />
      </div>

      <AgendaView
        currentView={currentView}
        currentAgendaTab={currentAgendaTab}
        setCurrentAgendaTab={setCurrentAgendaTab}
        appointments={appointments}
        miniSelectedDate={miniSelectedDate}
      />
    </div>
  );
}
